var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","padding":"40px"}},[(_vm.processing)?_c('p',[_vm._v("微信登录成功，正在处理...")]):(_vm.error)?_c('p',[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }